import referralRewardsEndpoints from "./endpoints/refer-balls.js";
import bankAccountEndpoints from "./endpoints/bank-account.js";
import topupEndpoints from "./endpoints/topup.js";
import transactionEndpoints from "./endpoints/transaction.js";
import withdrawEndpoints from "./endpoints/withdraw.js";
import gamesEndpoints from "./endpoints/games.js";
import rewardsEndpoints from "./endpoints/rewards.js";
import depositMethodEndpoints from "./endpoints/deposit-method.js";
import termConditions from "./endpoints/term-conditions.js";
import referralEndpoints from "./endpoints/referral.js";
import accountVariablesEndpoints from "./endpoints/account-variables.js";
import bannerEndpoints from "./endpoints/banner.js";
import promoInfoEndpoints from "./endpoints/promo-info.js";
import fundingProfileEndpoints from "./endpoints/funding-profile.js";
import personalInfo from "./endpoints/personal-info.js";
const siteTags = [
  "funding-tx",
  "game-tx",
  "bank-account",
  "games",
  "game-providers",
  "game-categories",
  "game-recent",
  "rewards",
  "deposit-methods",
  "term-conditions",
  "referral",
  "referral-tx",
  "referral-friend",
  "referral-stats",
  "account-variables",
  "banner",
  "referral-rewards",
  "promo-info",
  "funding-profile",
  "personal-info"
];
const siteAPIConfig = {
  reducerPath: "siteApi",
  tagTypes: siteTags,
  endpoints: (builder) => ({
    ...bankAccountEndpoints(builder),
    ...topupEndpoints(builder),
    ...transactionEndpoints(builder),
    ...withdrawEndpoints(builder),
    ...gamesEndpoints(builder),
    ...rewardsEndpoints(builder),
    ...depositMethodEndpoints(builder),
    ...termConditions(builder),
    ...referralEndpoints(builder),
    ...accountVariablesEndpoints(builder),
    ...bannerEndpoints(builder),
    ...referralRewardsEndpoints(builder),
    ...promoInfoEndpoints(builder),
    ...fundingProfileEndpoints(builder),
    ...personalInfo(builder)
  })
};
export {
  accountVariablesEndpoints,
  bankAccountEndpoints,
  bannerEndpoints,
  depositMethodEndpoints,
  fundingProfileEndpoints,
  gamesEndpoints,
  personalInfo as personalInfoEndpoints,
  promoInfoEndpoints,
  referralEndpoints,
  rewardsEndpoints,
  siteAPIConfig,
  siteTags,
  termConditions as termConditionsEndpoints,
  topupEndpoints,
  transactionEndpoints,
  withdrawEndpoints
};
